import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    backgroundColor: '#ffffff',
    fontFamily: 'Helvetica',
  },
  container: {
    width: '4.25in',
    height: '5.5in',
    backgroundColor: '#ffffff',
    padding: 5,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  mainContent: {
    flexDirection: 'row',
    marginBottom: 10,
  },
  leftColumn: {
    flex: 3,
    paddingRight: 15,
  },
  rightColumn: {
    flex: 2,
    alignItems: 'center',
  },
  logoDateHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  sampleTypeHeader: {
    fontSize: 11,
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
  sampleSubType: {
    fontSize: 5,
    marginLeft: 60,
    fontWeight: 'medium',
  },
  infoRow: {
    flexDirection: 'row',
    fontSize: 10,
    paddingVertical: 3,
  },
  label: {
    fontSize: 7,
    fontWeight: 'semibold',
  },
  labelData: {
    fontSize: 7,
    fontWeight: 'normal',
    marginLeft: 2,
  },
  sectionTitle: {
    fontSize: 7,
    fontWeight: 'semibold',
    marginBottom: 4,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#000',
  },
  commentsSection: {
    marginTop: 10,
    flexDirection: 'row',
  },
  commentsLeft: {
    flex: 1,
    marginRight: 10,
  },
  commentsRight: {
    flex: 1,
  },
  internalHeader: {
    fontSize: 7,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginBottom: 5,
  },
  lpnNumber: {
    fontSize: 7,
    fontWeight: 'semibold',
    marginTop: 2,
  },
  horizontalLine: {
    height: 1,
    backgroundColor: '#EBEBEB',
    marginBottom: 10,
    width: '100%',
  },
  verticalDivider: {
    width: 0.5,
    backgroundColor: '#000',
    marginHorizontal: 10,
  },
  productImagePlaceholder: {
    width: 80,
    height: 120,
    backgroundColor: '#f0f0f0',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 5,
  },
  barcodeContainer: {
    alignItems: 'center',
  },
  barcode: {
    width: 110,
    height: 30,
  },
  headerText: {
    fontSize: 5.5,
    fontWeight: 'semibold',
  },
  cellText: {
    fontSize: 7,
    fontWeight: 'normal',
  },
  smallText: {
    fontSize: 6,
    fontWeight: 'normal',
  },
});
